import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';

const columnHelper = createColumnHelper();

const generateColumn = col => ({
  cell: info => (
    col?.formatter ? col.formatter(info.getValue(), info.row?.original) : <>{info.getValue()}</>
  ),
  cellProps: {
    style: col?.style,
    className: `${col?.className || ''} ${col?.classes || ''}`,
  },
  headerStyle: col?.headerStyle,
  headerAttrs: {
    ...col?.headerAttrs || {},
    className: `${col.headerAttrs?.className || ''} ${col.searchable ? 'sortable' : ''}`,
  },
  header: () => col?.text || ' ',
  footer: info => info.column.id,
  enableSorting: col.sort,
  sortingFn: col?.sortingFn === undefined ? 'alphanumeric' : col?.sortingFn,
  searchable: col.searchable === undefined ? true : col.searchable,
  hidden: col.hidden === undefined ? false : col.hidden,
  id: col.dataField,
});

const translateColumns = (columns = []) => columns.map(col => {
  if (col?.dataField === 'actions') return columnHelper.display(generateColumn(col));
  return columnHelper.accessor(col.dataField, generateColumn(col));
});

export const translateSort = (sortBy = []) => sortBy.map(({ dataField, order }) => ({ id: dataField, desc: order === 'desc' }));

export default translateColumns;
